import PropTypes from "prop-types";

export const ContenedorPrincipal = ({ children }) => (
  <main className="institutional-content">{children}</main>
);

ContenedorPrincipal.propTypes = { children: PropTypes.node };
